<template>
    <div class="cont_principal">
        <div class="container">
            <div class="row">
                <div class="container-fluid">
                    <h3 class="title">MES PROJETS</h3>
                    <p class="col-12 color-darker">Rechercher un projet par thématique : </p>
                    <fg-select id="icategories" :options="categorie_projets" @update:selectedOptions="updateSelectedCategories" />
                    <n-button type="primary" round @click="removeAllFilters">Supprimer le filtre</n-button>

			<h5>Cliquez sur les projets pour avoir plus de détails</h5>
		</div>
		<div class="container-fluid">
			<div v-for="(projet, index) in filteredProjets" :key="index" class="div_card_proj" @click="toggleList(index, index)">
				<div>
					<h5 class="title_proj">{{ projet.nom }}</h5>
								<div>						
									<div v-for="(value, key) in projet.categorie" :key="key" :style="{ backgroundColor: getCouleur(value, categorie_projets) }" class="categorie"> {{ getCategorieNom(value, categorie_projets) }} </div>
								</div>
					<div v-if="selectedProjet === index">
						<div>
							<br />
							<strong class="year"> {{ projet.date }} </strong>
							<div>
								<p class="card-body" > {{ projet.description }} </p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	    </div>
	</div>        
    </div>
</template>

<script>
    import FormGroupSelected from '../components/Inputs/formGroupSelected.vue';
    import { Card } from '@/components';
    import { Button } from '@/components';
    import { Carousel, CarouselItem } from 'element-ui';

    export default {
        name: 'Projets',
        props: ["projets", "categorie_projets", "img_projets"],
        components: {
	    [Card.name]: Card,
            [FormGroupSelected.name]: FormGroupSelected,
            [Button.name]: Button
        },
        methods: {
            getCouleur(categorie_key, categorie_projets) {
                return categorie_projets[categorie_key].couleur
            },
            getCategorieNom(categorie_key, categorie_projets) {
                return categorie_projets[categorie_key].nom
            },
            updateSelectedCategories(newSelectedCategories) {
                this.selectedCategories = newSelectedCategories;
            },
            removeAllFilters() {
                this.selectedCategories = [];
                this.$emit("change", this.selectedCategories)
            },
            getImg(img) {
                return require('../../public/img/' + img);
            },
	    toggleList(category, index) {
	      if (this.selectedCategory === category && this.selectedProjet === index) {
	        // Déselectionner le projet si elle était déjà sélectionné
		this.selectedCategory = null;
	        this.selectedProjet = null;
	      } else {
	        // Sélectionner le projet si il n'était pas encore sélectionné
	        this.selectedCategory = category;
		this.selectedProjet = index;
	      }
	  }
        },
        computed: {
            projetsArray() {
                const projets = Array.isArray(this.projets) ? this.projets : Object.values(this.projets);

                return projets.map((projet) => {
                    return { ...projet, categorie: Array.isArray(projet.categorie) ? projet.categorie : Object.values(projet.categorie) };
                });
            },
            filteredProjets() {
                const selectedCategories = this.selectedCategories;

                if (this.selectedCategories.length === 0) {
                    return this.projetsArray;
                } else {
                    return this.projetsArray.filter(projet => {
                        return projet.categorie.some(category => selectedCategories.includes(category));
                    });
                }
            }
        },
	data() {
            return {
                selectedCategories: [],
		selectedProjet: null,
            };
        }
    };
</script>

<style>
   .card {
	background-color: transparent;
   }

.div_card_proj {
        display: inline-block;
        margin: 15px;
	width:80%;
        padding: 20px;
        box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2);
}

.div_card_proj:hover {
        box-shadow: 0px 10px 50px 0px rgba(0,0,0,0.2);
}

    .title_proj {
	font-weight: bold;
	padding: 2px;
	margin: 5px;
    }

    .cont_principal {
        margin: 0px;
        padding: 0px;
        background-color: #313131;
        color: white;
    }

    .categorie {
        border-radius: 20px;
        display: inline-block;
        color: white;
        font-weight: bold;
        padding: 5px;
        padding-left: 10px;
        padding-right: 10px;
        width: auto;
        margin: 5px;
        font-size: 14px;
    }

    .resume-item {
        margin-bottom: 25px;
        padding-top: 20px;
        text-align: center;
        p

    {
        font-size: 1.5rem;
        margin-top: 0;
    }

    .resume-description {
        font-size: 1rem;
    }

    .year {
        font-weight: 600;
        margin-bottom: 5px;
    }

    }

    .container-fluid {
        display: inline-block;
    }

    fg-select {
        margin: 0px;
        padding: 0px;
    }
</style>
